var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fluid" },
    [
      _c("br"),
      _vm._m(0),
      _c(
        "b-card",
        [
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.voltar()
                }
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { xs: "12", sm: "6", md: "6", lg: "6", xl: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "text-label", attrs: { label: "Nome" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "nome",
                              disabled: "",
                              title: "Nome",
                              "data-vv-name": "nome",
                              placeholder: "Nome"
                            },
                            model: {
                              value: _vm.recurso.nome,
                              callback: function($$v) {
                                _vm.$set(_vm.recurso, "nome", $$v)
                              },
                              expression: "recurso.nome"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        xs: "12",
                        sm: "12",
                        md: "12",
                        lg: "12",
                        xl: "12"
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "text-label",
                          attrs: { label: "Descrição" }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "descricao",
                              disabled: "",
                              title: "Descrição",
                              "data-vv-name": "descricao",
                              placeholder: "Descrição"
                            },
                            model: {
                              value: _vm.recurso.descricao,
                              callback: function($$v) {
                                _vm.$set(_vm.recurso, "descricao", $$v)
                              },
                              expression: "recurso.descricao"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { align: "right" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        outline: "",
                        size: "md",
                        type: "submit",
                        variant: "secondary",
                        title:
                          "Voltar para tela de pesquisa de Recurso de Acessibilidade"
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-arrow-left" }),
                      _vm._v(" Voltar\n                ")
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "app-title" }, [
      _c("i", { staticClass: "fas fa-universal-access" }),
      _vm._v(" Exibir Recurso de Acessibilidade\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }